<template>
  <div class="faqList">
    <top-header></top-header>
    <b-container style="margin-top: 5%;margin-bottom:6%;">
      <b-row>
        <b-col lg="7" md="7" sm="12" class="px-3 text-left">
          <div class="heading">Frequently Asked Questions <small>(FAQ)</small></div>
        </b-col>
		<b-col lg="5" md="5" sm="12" class="py-3  linkFa">
			<b-button :href="urlWhatapp" target="_blank" class="chn"> <i class="fa fa-whatsapp" aria-hidden="true"></i> Chat Now!</b-button>
			<b-button href="/survey" class="fbf"> <i class="fa fa-wpforms" aria-hidden="true"></i> Feedback Form</b-button>
        </b-col>
      </b-row>
    </b-container>
	
	 <b-container class="mt-5">
		 <b-row>
			<b-col lg="6" md="6" sm="12">
				<b-card class="p-0">
				<div class="card-header border-0"  v-b-toggle.faq1 variant="info">
					<b-row>
						<b-col cols="11">What is Alluraa?</b-col> 
						<b-col cols="1" class="pl-0"><i class="fa fa-caret-down"></i> </b-col>
					</b-row> 
				</div>
				<b-collapse id="faq1"   accordion="my-accordion" role="tabpanel" class="font14">
					Alluraa is a Direct to Customer (D2C) Social Selling online market place that uses the power of social selling in an organized setup.
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq3 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Who can sell products on Alluraa?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq3"   accordion="my-accordion" role="tabpanel" class="font14">
					Everyonewho want to increase their sales and showcase their products across India is welcome on the platform.
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq5 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Does Alluraa.com have a tie-up with any delivery partner?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq5"   accordion="my-accordion" role="tabpanel" class="font14">
					Yes, for convenience Sellers have a choice to use the delivery partner who has been integrated with the site. Sellers can opt for their trusted delivery partner if they wish so.
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq7 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">How can we list the products on the site?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq7"   accordion="my-accordion" role="tabpanel" class="font14">
					Alluraa is an easy to use platform designed keeping Sellers in mind so that they can list the products themselves. Cataloguing team at Alluraa can also help with cataloguing if any Seller finds it difficult during the listing process. 
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq9 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">What are the charges for Sellers?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq9"   accordion="my-accordion" role="tabpanel" class="font14">
					<p>
					Alluraa is a Partner for Sellers and Influencer. Alluraa does not charge anything to the seller.  Seller needs to incur expenses only when a sales order is generated.
					</p>
					<p>
					Below charges are pre-defined for the Seller:
					<ul>
						<li>A) Incentive to the Influencer as decided by you <br/> <b>i.e.</b> Influencer commission.</li>
						<li>B) Fixed 5% as administrative charges</li>
					
					</ul>
					</p>
				</b-collapse>
				</b-card>
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq11 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Is there any training for influencer?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq11"   accordion="my-accordion" role="tabpanel" class="font14">
					<p>
					Yes, there are periodic trainings to the influencers. These training covers the soft selling skills and knowledge about the brands and products.
					</p>
					
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq13 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Can the influencer work from home?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq13"   accordion="my-accordion" role="tabpanel" class="font14">
					<p>
					Yes, earn from anywhere and anytime. 
					</p>
					
				</b-collapse>
				</b-card>
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq15 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Who can become an influencer?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq15"   accordion="my-accordion" role="tabpanel" class="font14">
					<p>
					Everyone who desires for financial freedom can be part of Alluraa team. We welcome students, home makers to be part of the ever increasing and happy influencer at Alluraa, to earn more and be independent <b>"Be your Own Boss"</b>
					</p>
					
				</b-collapse>
				</b-card>
				
				
				
				
			</b-col>
			<b-col lg="6" md="6" sm="12">
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq2 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">What kind of products can be sold on Alluraa.com?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq2"   accordion="my-accordion" role="tabpanel" class="font14">
					Alluraa focuses on fast selling categories like apparels, cosmetics, handloom, handicrafts, home décor and organic products.<br/>
					We welcome young brands of India, craftsmen, artists and all those who want to take the rich heritage of Indian products across India.
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq4 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">Who is responsible to ship the products to customers?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq4"   accordion="my-accordion" role="tabpanel" class="font14">
					Alluraa is an online platform. Alluraais a drop ship modelso all the orders received are immediately communicated to the sellers, who can print the label, prepare invoice and ship the product to the customers.
				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq6 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">How does the seller track sales, payment and inventory?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq6"   accordion="my-accordion" role="tabpanel" class="font14">
					Every seller has access to their individual and easy to use dashboard, which provides the details of sales, pending orders to be shippedand also provide information related to inventory and stock updates. Sellers can also track what's selling and is in high demand.<br/>
Also,our MIS system allows you to print invoices and shipment labels etc.

				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq8 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">How to manage inventory and discounts?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq8"   accordion="my-accordion" role="tabpanel" class="font14">
				
					There are in-built features on the dashboard to update inventory and discounts.

				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq10 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">What is the role of an Influencer?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq10"   accordion="my-accordion" role="tabpanel" class="font14">
				
					Influencer are the connecting link between Seller/brand and Customers. Influencer are the unique and most important part of Alluraa team. They promote and sell the products listed on Alluraa by reaching out to customers in their contact list or neighborhoodby sharing product links and custom messages over WhatsApp, Facebook,Telegram,Text messages and Email. Influencer can send customized messages which can be personalized and can be in the language of the customers.

				</b-collapse>
				</b-card>
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq12 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">How does the Influencers earn?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq12"   accordion="my-accordion" role="tabpanel" class="font14">
				
					<p>Influencer earn on every sale that they make. There is an incentive on sales of each product.  This incentive is displayed on the site and visible only to the Advisor, so they can choose the product which has maximum Incentive and sells the most.</p>

				</b-collapse>
				</b-card>
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq14 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">How much can the influencer earn?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq14"   accordion="my-accordion" role="tabpanel" class="font14">
				
					<p>the more the Sale the more he earning! it is complete financial freedom and an opportunity to be your own boss. Be your own boss with Alluraa!</p>

				</b-collapse>
				</b-card>
				
				
				<b-card class="p-0">
				<div class="card-header border-0" block v-b-toggle.faq16 variant="info">
					<b-row  class=" align-items-center">
						<b-col cols="11">What are general Terms & Condition for Sellers?</b-col> 
						<b-col cols="1" class="pl-0 text-right"><b-link > <i class="fa fa-caret-down"></i> </b-link></b-col>
					</b-row> 
				</div>
				<b-collapse id="faq16"   accordion="my-accordion" role="tabpanel" class="font14">
				
					<p>
						<ul style="list-style: disc;">
							<li>Zero Registration Fee</li>
							<li>Free Support for listing of products</li>
							<li>Payout Every 15 days
								
							</li>
							<li>Commission applied only when Sales are made (as below)
								<ul style="list-style: circle;">
									<li>Influencer Commission (Set by the Seller)</li>
									<li>Website Commission of 5%</li>
								</ul>
							</li>
							<li>Packing & Shipping to be done by the Seller</li>
							<li>Order Details are sent on seller Dashboard & Email</li>

						
						</ul>
					
					</p>

				</b-collapse>
				</b-card>


				
  
			</b-col>
		</b-row>
	</b-container>
    

    
 
	
	
	
	
   
    <bottom-footer></bottom-footer>
    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Faq",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
		if(window.innerWidth < 700){
			//this.urlWhatapp='https://wa.me/send?text=&phone=918920670756';
			this.urlWhatapp='https://api.whatsapp.com/send?text=&phone=918920670756';
		 }
		this.init();
	},
  data() {
    return {
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: ""
      },
      team:[
        {id:1, img:'', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that enable people from every stratum to earn an earnest livelihood.'},
        {id:2, img:'', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to enable the common man by leveraging technology and innovation.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 110, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { blank: true, blankColor: '#b7b7b7', width: 300, height: 300, fluidGrow: true, class: 'm1' },
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 50
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 150
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      },
	   urlWhatapp:'https://web.whatsapp.com/send?text=&phone=918920670756',
    }
  },
  methods: {
    init(){
      var self = this;
      if(self.$route.params.param_role){
        self.customer.role = self.$route.params.param_role;
        self.$root.role = self.$route.params.param_role;
      //  self.customer.workarea = self['workarea_'+self.$route.params.param_role];
      }
      
      //alert(self.customer.role.replace('-',''));
      self.workarea_options = self['workarea_'+self.customer.role.replace('-','')];
      //self.customer.workarea = 
      //alert(self['workarea_'+self.customer.role]);
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
    submitRegistration(){
      var self = this;
      var valid = true;
      self.form_alert = [];
      if(self.customer.fullname == ''){
        //self.form_alert.push("Full name is required!");
        valid = false;
      }
      if(self.customer.email == '' && self.customer.mobile == '' ){
        //self.form_alert.push("Email or mobile is required!");
        valid = false;
      }
      if(self.terms_condition == 'not_accepted'){
        //self.modal.msg = "Please accept terms and condition!";
        //self.$bvModal.show('modal-status');
        self.form_alert.push("Terms and condition is required!");
        valid = false;
        //return;
      }
      var mobile = self.customer.mobile;
      if(mobile.length < 10){
        self.form_alert.push('Please add a valid mobile number!');
        valid = false;
      }
      if(self.customer.workarea == ''){
        valid = false;
      }
      
      if(!self.validateemail(self.customer.email)){
        self.form_alert.push('Please add a valid email!');
        self.form_alert.push('All fields are mandatory!');
        valid = false;
      }else{
        console.log('Valid email format!');
      }

      if(valid == false){
        return;
      }

      var workarea = '';
      if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
      }else{
        workarea = self.customer.workarea;
      }
      
			self.axios.post(self.$root.WEBURL+'registration', {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: self.customer.role,
        location: self.customer.location,
        workarea: workarea
			})
			.then(function (response) {
        
				if(response.data.error == 0 || response.data.error == '0'){
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a influencer!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.$bvModal.show('modal-status');
				}else if(response.data.error == 1){
          self.modal.msg = "Registration Failed! Try agin later!";
					self.$bvModal.show('modal-status');
				}else if(response.data.error == 2){
          self.modal.msg = "Registration Failed! Email or mobile allready exist!";
					self.$bvModal.show('modal-status');
				}
			})
			.catch(function (error) {
				alert(error);
			});
    }
  },
  metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: 'alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
<style   scoped lang="scss">
    /* .imgSh{width: 86%;
    height: 85px;
    border: 1px Solid #c6c6c6;
	} */
	.faqList{
		.card {
			margin-bottom:9%;
			&-body {
			padding: 2px;
			}
			&-header{
				padding-top:5px;
				padding-bottom:5px;
				padding-left: 9px;
			}
			
			
		}
		.font14{
		font-size:14px;
		padding: 9px;
		line-height: 22px;
		word-spacing: 4px;
		}
		
		.linkFa{
				
				a{
				    
					font-size: 16px;
					background: #c6c6c62e;
					border: 1px solid #c6c6c6; 
					border-radius: 5px;
					
					color:#000;
						
					}
					.chn{
							margin-right:14%;
							i{
								color:#25ac38;
								font-size: 19px;
							}
						}
					.fbf{
							
							i{
								color:red;
							}
						}
			}
		
	}
	
	
		

</style>
